package com.daytimegaming.ourdailyfinances.di

import com.daytimegaming.ourdailyfinances.domain.event.RealtimeEventStreamManager
import com.daytimegaming.ourdailyfinances.domain.fcm.FcmManager
import com.daytimegaming.ourdailyfinances.domain.fcm.FcmManagerImpl
import com.daytimegaming.ourdailyfinances.domain.usecase.AccountUseCase
import com.daytimegaming.ourdailyfinances.domain.usecase.AddDashboardAccount
import com.daytimegaming.ourdailyfinances.domain.usecase.AddDashboardRealEstateHolding
import com.daytimegaming.ourdailyfinances.domain.usecase.AuthUseCase
import com.daytimegaming.ourdailyfinances.domain.usecase.BudgetUseCase
import com.daytimegaming.ourdailyfinances.domain.usecase.CreateBudget
import com.daytimegaming.ourdailyfinances.domain.usecase.CreateConsentUpdateLinkToken
import com.daytimegaming.ourdailyfinances.domain.usecase.CreateDashboard
import com.daytimegaming.ourdailyfinances.domain.usecase.CreateInvite
import com.daytimegaming.ourdailyfinances.domain.usecase.CreateLinkToken
import com.daytimegaming.ourdailyfinances.domain.usecase.CreateRealEstateHolding
import com.daytimegaming.ourdailyfinances.domain.usecase.CreateUpdateLinkToken
import com.daytimegaming.ourdailyfinances.domain.usecase.DashboardUseCase
import com.daytimegaming.ourdailyfinances.domain.usecase.DeleteBudget
import com.daytimegaming.ourdailyfinances.domain.usecase.DeleteDashboard
import com.daytimegaming.ourdailyfinances.domain.usecase.DeleteRealEstateHolding
import com.daytimegaming.ourdailyfinances.domain.usecase.ExchangePublicToken
import com.daytimegaming.ourdailyfinances.domain.usecase.GetAccounts
import com.daytimegaming.ourdailyfinances.domain.usecase.GetBudgets
import com.daytimegaming.ourdailyfinances.domain.usecase.GetCurrentUser
import com.daytimegaming.ourdailyfinances.domain.usecase.GetDashboardDetail
import com.daytimegaming.ourdailyfinances.domain.usecase.GetDashboards
import com.daytimegaming.ourdailyfinances.domain.usecase.GetIdToken
import com.daytimegaming.ourdailyfinances.domain.usecase.GetPlaidItems
import com.daytimegaming.ourdailyfinances.domain.usecase.GetRealEstateHolding
import com.daytimegaming.ourdailyfinances.domain.usecase.GetRealEstateHoldings
import com.daytimegaming.ourdailyfinances.domain.usecase.GetUserProfile
import com.daytimegaming.ourdailyfinances.domain.usecase.JoinDashboard
import com.daytimegaming.ourdailyfinances.domain.usecase.LeaveDashboard
import com.daytimegaming.ourdailyfinances.domain.usecase.LoginUser
import com.daytimegaming.ourdailyfinances.domain.usecase.PreviewInviteCode
import com.daytimegaming.ourdailyfinances.domain.usecase.RealEstateUseCase
import com.daytimegaming.ourdailyfinances.domain.usecase.RefreshRealEstateValueEstimate
import com.daytimegaming.ourdailyfinances.domain.usecase.RegisterUser
import com.daytimegaming.ourdailyfinances.domain.usecase.RegisterUserProfile
import com.daytimegaming.ourdailyfinances.domain.usecase.RemoveDashboardAccount
import com.daytimegaming.ourdailyfinances.domain.usecase.RemoveDashboardRealEstateHolding
import com.daytimegaming.ourdailyfinances.domain.usecase.RevokeInvite
import com.daytimegaming.ourdailyfinances.domain.usecase.SignOutUser
import com.daytimegaming.ourdailyfinances.domain.usecase.UnlinkPlaidItem
import com.daytimegaming.ourdailyfinances.domain.usecase.UpdateAccountNickname
import com.daytimegaming.ourdailyfinances.domain.usecase.UpdateBudget
import com.daytimegaming.ourdailyfinances.domain.usecase.UpdateDashboard
import com.daytimegaming.ourdailyfinances.domain.usecase.UpdateRealEstateHolding
import com.daytimegaming.ourdailyfinances.domain.usecase.UpdateUserProfile
import com.daytimegaming.ourdailyfinances.domain.usecase.UserUseCase
import org.koin.dsl.module

fun useCaseModule() = module {
    single { GetCurrentUser(get()) }
    single { LoginUser(get()) }
    single { RegisterUser(get()) }
    single { SignOutUser(get()) }
    single { GetIdToken(get()) }
    single { AuthUseCase(get(), get(), get(), get(), get()) }

    single { GetUserProfile(get()) }
    single { RegisterUserProfile(get()) }
    single { UpdateUserProfile(get()) }
    single { UserUseCase(get(), get(), get()) }

    single { GetDashboards(get()) }
    single { GetDashboardDetail(get()) }
    single { CreateDashboard(get()) }
    single { AddDashboardAccount(get()) }
    single { CreateInvite(get()) }
    single { RevokeInvite(get()) }
    single { PreviewInviteCode(get()) }
    single { JoinDashboard(get()) }
    single { LeaveDashboard(get()) }
    single { RemoveDashboardAccount(get()) }
    single { UpdateDashboard(get()) }
    single { DeleteDashboard(get()) }
    single { AddDashboardRealEstateHolding(get()) }
    single { RemoveDashboardRealEstateHolding(get()) }
    single { DashboardUseCase(get(), get(), get(), get(), get(), get(), get(), get(), get(), get(), get(), get(), get(), get()) }

    single { GetAccounts(get()) }
    single { CreateLinkToken(get()) }
    single { CreateUpdateLinkToken(get()) }
    single { CreateConsentUpdateLinkToken(get()) }
    single { ExchangePublicToken(get()) }
    single { GetPlaidItems(get()) }
    single { UnlinkPlaidItem(get()) }
    single { UpdateAccountNickname(get()) }
    single { AccountUseCase(get(), get(), get(), get(), get(), get(), get(), get()) }

    single { GetBudgets(get()) }
    single { CreateBudget(get()) }
    single { UpdateBudget(get()) }
    single { DeleteBudget(get()) }
    single { BudgetUseCase(get(), get(), get(), get()) }

    single { CreateRealEstateHolding(get()) }
    single { GetRealEstateHoldings(get()) }
    single { GetRealEstateHolding(get()) }
    single { UpdateRealEstateHolding(get()) }
    single { DeleteRealEstateHolding(get()) }
    single { RefreshRealEstateValueEstimate(get()) }
    single { RealEstateUseCase(get(), get(), get(), get(), get(), get()) }

    single<FcmManager>(createdAtStart = true) { FcmManagerImpl(get(), get()) }
    single(createdAtStart = true) { RealtimeEventStreamManager(get(), get(), get(), get()) }
}
